import { footerLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-[17px] text-foreground-950">
                  美丽的小蜜桃
                </span>
                <span className="text-[10px] tracking-[0.28em] text-foreground-500 mt-0.5">
                  PHOTO &amp; VIDEO ARCHIVE
                </span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mt-4 max-w-md">
              个人写真与视频资源集中地，收录高清套图、私拍福利与精选美图。
              我们希望把她的写真合集、视频资源与套图大全，整理成一个顺畅好逛的资源导航站。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="站点社交入口"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-bold text-foreground-950 text-base mb-4">
                <a href="#top" className="hover:text-primary-600 transition-colors">
                  {group.title}
                </a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 美丽的小蜜桃 · 写真视频资源聚合站 · 内容仅供个人观赏收藏
          </p>
          <div className="flex items-center gap-5">
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              站点声明
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              常见问题
            </a>
            <a href="#subscribe" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              订阅更新
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}